var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "FilterListBlock",
    {
      staticClass: "filter-list filter-list--range",
      attrs: {
        name: _vm.filter.filter_name,
        "search-input-id": _vm.searchInputIdFrom
      }
    },
    [
      _c(
        "form",
        {
          staticClass: "filter-range",
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.setRange.apply(null, arguments)
            }
          }
        },
        [
          _c("div", { staticClass: "filter-range__inputs" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.trim",
                  value: _vm.fromField,
                  expression: "fromField",
                  modifiers: { trim: true }
                }
              ],
              staticClass: "input-custom--small browser-reset",
              attrs: {
                id: _vm.searchInputIdFrom,
                inputmode: "decimal",
                type: "text",
                name: "from",
                placeholder: _vm.i18n("from price"),
                "aria-label":
                  "Wyszukiwanie w filtrze " +
                  _vm.i18n("from price") +
                  " – pole edycji"
              },
              domProps: { value: _vm.fromField },
              on: {
                input: [
                  function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.fromField = $event.target.value.trim()
                  },
                  _vm.onInput
                ],
                blur: [
                  _vm.onBlur,
                  function($event) {
                    return _vm.$forceUpdate()
                  }
                ]
              }
            }),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.trim",
                  value: _vm.toField,
                  expression: "toField",
                  modifiers: { trim: true }
                }
              ],
              staticClass: "input-custom--small browser-reset",
              attrs: {
                id: _vm.searchInputIdTo,
                type: "text",
                name: "to",
                inputmode: "decimal",
                placeholder: _vm.i18n("to price"),
                "aria-label":
                  "Wyszukiwanie w filtrze " +
                  _vm.i18n("to price") +
                  " – pole edycji"
              },
              domProps: { value: _vm.toField },
              on: {
                input: [
                  function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.toField = $event.target.value.trim()
                  },
                  _vm.onInput
                ],
                blur: [
                  _vm.onBlur,
                  function($event) {
                    return _vm.$forceUpdate()
                  }
                ]
              }
            })
          ]),
          _vm._v(" "),
          _c(
            "button",
            { staticClass: "filter-range__btn" },
            [
              _c("span", [_vm._v(_vm._s(_vm.i18n("Update price")))]),
              _vm._v(" "),
              _c("ReloadIcon", { attrs: { width: "18", height: "18" } })
            ],
            1
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }